// -- == //
import EventForm from '../lib/eventForm';
import AppLoading from 'components/appLoading';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function EventCreatePage() {
  const { eventCreate, eventUpload, contributorUploadQuest } = useTypedSelector((state: any) => state.Events);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      <PageTitle title="Create New Event" />
      <EventForm data={{} as any} departments={departments.data} loading={eventCreate.loading} />

      <AppLoading
        loading={eventCreate.loading || eventUpload.loading || departments.loading || contributorUploadQuest.loading}
      />
    </S.Container>
  );
}
